// The full color scale of `packages/pixel/tokens/color.css`, including the
// tint/shade variants (e.g. `master-dark`) that `kb-text` defaults to and
// resolves against — unlike `kb-icon`/`kb-button`, which only ever need the
// base family name. `color` resolves to `--color-{value}`, so the closed set
// is what keeps an unknown value from reaching the custom property and
// injecting CSS.
export const COLORS = Object.freeze({
  MASTER_DARKEST: 'master-darkest',
  MASTER_DARKER: 'master-darker',
  MASTER_DARK: 'master-dark',
  MASTER: 'master',
  MASTER_LIGHT: 'master-light',
  MASTER_LIGHTER: 'master-lighter',
  MASTER_LIGHTEST: 'master-lightest',
  PRIMARY_DARKER: 'primary-darker',
  PRIMARY_DARK: 'primary-dark',
  PRIMARY: 'primary',
  PRIMARY_LIGHT: 'primary-light',
  PRIMARY_LIGHTER: 'primary-lighter',
  COMPLETE_DARKER: 'complete-darker',
  COMPLETE_DARK: 'complete-dark',
  COMPLETE: 'complete',
  COMPLETE_LIGHT: 'complete-light',
  COMPLETE_LIGHTER: 'complete-lighter',
  SUCCESS_DARKER: 'success-darker',
  SUCCESS_DARK: 'success-dark',
  SUCCESS: 'success',
  SUCCESS_LIGHT: 'success-light',
  SUCCESS_LIGHTER: 'success-lighter',
  WARNING_DARKER: 'warning-darker',
  WARNING_DARK: 'warning-dark',
  WARNING: 'warning',
  WARNING_LIGHT: 'warning-light',
  WARNING_LIGHTER: 'warning-lighter',
  DANGER_DARKER: 'danger-darker',
  DANGER_DARK: 'danger-dark',
  DANGER: 'danger',
  DANGER_LIGHT: 'danger-light',
  DANGER_LIGHTER: 'danger-lighter',
  INFO_DARKER: 'info-darker',
  INFO_DARK: 'info-dark',
  INFO: 'info',
  INFO_LIGHT: 'info-light',
  INFO_LIGHTER: 'info-lighter',
  MENU_DARK: 'menu-dark',
  MENU: 'menu',
  MENU_LIGHT: 'menu-light',
  PURE_WHITE: 'pure-white',
  PURE_BLACK: 'pure-black',
})
